exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crowdfund-token-header[data-v-2649e3bd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 2.3rem;\n}\n.crowdfund-token__icon[data-v-2649e3bd] {\n  width: 6rem;\n  height: 6rem;\n  margin-right: 2rem;\n  border-radius: 50%;\n  border: 1px solid #2C3030;\n}\n.crowdfund-token__name[data-v-2649e3bd] {\n  padding-bottom: 0.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2649e3bd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/sale_details/tabs/Sales.TokenTab.vue
// module id = nYPi
// module chunks = 1